import { render, staticRenderFns } from "./PostImportHorseList.vue?vue&type=template&id=438a176e&"
import script from "./PostImportHorseList.vue?vue&type=script&lang=js&"
export * from "./PostImportHorseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports